import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { GzRunNetworkDiscoveryWebComponent } from './component/GzRunNetworkDiscoveryWebComponent';
import { translateFn } from '../../../../utils/translator.helper';
import { CreateTaskRequest } from '../../types';
import { getFormattedDateForTask } from '../../../networkAppContainer/helpers/utils';

export class RunNetworkDiscoveryPopUp extends NetworkBasePopUp<GzRunNetworkDiscoveryWebComponent> {
  protected transformToTaskTarget = true;
  protected title = translateFn('Run network discovery');
  protected extraDialogConfigs = {
    isWindow: false,
  };

  protected customSetup() {
    this.popUpContent = new GzRunNetworkDiscoveryWebComponent();
  }

  protected handleConfirmButtonClicked(event: CustomEvent): Promise<void> {
    const payload: CreateTaskRequest = {
      settings: {
        targets: this.data.targets || [],
        taskName: translateFn('Network Discovery ') + getFormattedDateForTask(),
        type: Constants.Tasks.Endpoints.TASK_TYPE_NETWORK_DISCOVERY_PARENT,
      },
    };

    return this.createTask(payload);
  }
}
